import { render } from "./ManageRequisitions.vue?vue&type=template&id=47e0207d"
import script from "./ManageRequisitions.vue?vue&type=script&lang=js"
export * from "./ManageRequisitions.vue?vue&type=script&lang=js"

import "./ManageRequisitions.vue?vue&type=style&index=0&id=47e0207d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__